import { createContext, useContext } from "react";

import { WorkflowEdge } from "@/components/Workflows/types";

type ContextType =
  | {
      linkedDependencies?: string[];
      edge?: WorkflowEdge;
    }
  | undefined;

const defaultContextValue: ContextType = undefined;

export const TargetNodeContext = createContext<ContextType>(defaultContextValue);

export const EdgeContextProvider = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: ContextType;
}) => <TargetNodeContext.Provider value={value}>{children}</TargetNodeContext.Provider>;

export const useLinkedDependencies = () => useContext(TargetNodeContext)?.linkedDependencies || [];

export const useEdge = () => useContext(TargetNodeContext)?.edge;
